<template>
    <div class="bg-white p-1 lg:p-4 rounded">
        <apexcharts :options="options" :series="series"></apexcharts>
    </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
    components: {
        apexcharts: VueApexCharts,
    },
    data() {
        return {
            series: [{
                name: 'Income',
                data: [44, 55, 57, 56, 61, 58, 63, 60, 66]
            }, {
                name: 'Orders',
                data: [76, 85, 101, 98, 87, 105, 91, 114, 94]
            }, {
                name: 'User',
                data: [35, 41, 36, 26, 45, 48, 52, 53, 41]
            }],
            options: {
                chart: {
                    type: 'bar',
                    toolbar: {
                        show: false
                    }
                },
                plotOptions: {
                    bar: {
                        horizontal: false,
                        columnWidth: '55%',
                        endingShape: 'rounded'
                    },
                },
                colors: ['#60A5FA', '#FCA5A5', '#FBBF24'],
                dataLabels: {
                    enabled: false
                },
                stroke: {
                    show: true,
                    width: 1.5,
                    colors: ['#60A5FA', '#FCA5A5', '#FBBF24']
                },
                xaxis: {
                    categories: ['Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct'],
                },
                yaxis: {
                    title: {
                        text: '$ (thousands)'
                    }
                },
                fill: {
                    opacity: 0.4
                },
                tooltip: {
                    y: {
                        formatter(val) {
                            return "$ " + val + " thousands"
                        }
                    }
                }
            },

        }
    }
}
</script>

<style>

</style>